import { UpgradePromotion } from "common/elements";
import { UserDashboard } from "features/user";
import { ProjectPreview } from "features/preview";
import { Rating, Feedback } from "features/review";
import { AssistantDialog } from "features/assistant";
import { SmartAppBanner, PwaInstallBanner } from "features/install";
import { ParentShakeBugReportDialog } from "features/parent/components";
import { Contact, UniversalPanel, ShakeBugReportDialog } from "features/universal";
import { PurchaseResultHandler, RestrictedFeatureDialog } from "features/subscription";
import { ParentAccountAuthDialog, ParentRegistrationPromptDialog } from "features/auth";
import { AppLoading } from "./AppLoading";

export const DialogPage = () => {
  return (
    <>
      <Rating />
      <Contact />
      <Feedback />
      <UserDashboard />
      <AppLoading />
      <AssistantDialog />
      <UniversalPanel />
      <ShakeBugReportDialog />
      <ParentShakeBugReportDialog />
      <ProjectPreview />
      <SmartAppBanner />
      <RestrictedFeatureDialog />
      <PwaInstallBanner />
      <UpgradePromotion />
      <PurchaseResultHandler />
      <ParentAccountAuthDialog />
      <ParentRegistrationPromptDialog />
    </>
  );
};
